import { render, staticRenderFns } from "./yButton.vue?vue&type=template&id=e8dbab56&scoped=true&"
import script from "./yButton.js?vue&type=script&lang=js&"
export * from "./yButton.js?vue&type=script&lang=js&"
import style0 from "./yButton.less?vue&type=style&index=0&id=e8dbab56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dbab56",
  null
  
)

export default component.exports